// extracted by mini-css-extract-plugin
export default {"visualizer":"Playground_visualizer__1e5mj","animatedPanels":"Playground_animatedPanels__GRy7g"};